<mat-tab-group>
  <mat-tab label="Today"> Content 1 </mat-tab>
  <mat-tab label="Notifications"> Content 2 </mat-tab>
</mat-tab-group>
